<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page" v-show="show">
      <div class="col-lg-12">
        <div class="signup-page--right">
            <div class="form-help">
              <span>{{ getTranslations.visitor_forgot_password_1_recover_your_password }}</span>
            </div>
          <div class="progressbar-container" v-if="!hasSimplify()">
            <ol class="progress">
              <li class="is-active" data-step="1">
              </li>
              <li class="" data-step="2">
              </li>
              <li data-step="3" class="progress__last">
              </li>
            </ol>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <p>{{ getTranslations.visitor_forgot_password_1_no_worries_msg }}</p>
              <img class="form-help__icon"
                   v-if="!hasResub()"
                   src="static/images/mobile-icon.svg"
                   alt="">
            </div>
            <OperatorSelection v-if="hasResub()"
                                @choose="onOperatorChoose"
                                :error="operatorError">
            </OperatorSelection>
            <div v-if="multiOperatorInfo.multiOperatorEnabled" class="operators_selection_wrap ">
              <h1>{{ getTranslations.home_modals_select_operator_my_operator_is }}</h1>
              <div class="operators_radio">
                <label v-for="(op, index) in multiOperatorInfo.multiOperatorKeys"
                       :key="index"
                       class="operators_radio operators_radio_inline">
                  <img class="operators_icon"
                       :src="getOperatorImage(index)"
                       :alt="getOperatorDisplayName(index)">
                  <input type="radio"
                         name="operator"
                         @click="onOperatorSelect(op)"
                         :value="op">
                  <span></span>
                </label>
              </div>
              <div class="form-group form-group--icon fb_login has-warning operators_error_msg"
                   v-if="noOperatorSelected && user.operator==''">
                  <span class="form-group__feedback">
                    {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
                  </span>
              </div>
            </div>
            <form action="">
              <div class="form-group form-group--mobile"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text" class="form-group__textfield"
                       :placeholder="getTranslations.visitor_forgot_password_1_enter_mobile_number"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <input type="submit" :value="getTranslations.visitor_forgot_password_1_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( hasErrors ? 'deactivated' : '')]" @click.prevent="checkButton">
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import OperatorSelection from '@/components/visitor/forgotPassword/OperatorSelection';

export default {
  name: 'forgotPassword1',
  mixins: [RegistrationFlowMixin],
  components: { OperatorSelection },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  data() {
    return {
      user: {
        msisdn: '',
        operator: '',
      },
      show: true,
      message: '',
      hasErrors: false,
      operatorError: false,
      noOperatorSelected: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo',
    ]),
    showPage(value) {
      this.show = value;
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.user.operator = operator;
    },
    getIntegration(to) {
      this.getIntegrationParametersCheck()(to);
    },
    onOperatorChoose(operator) {
      this.hasErrors = false;
      this.message = '';
      this.user.operator = operator;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.user.msisdn = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      let validMsisdnRegex = /^[0-9]{0,20}$/;
      if (this.conversionForArabicFields) validMsisdnRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      this.operatorError = !this.user.operator;
      if (this.multiOperatorInfo.multiOperatorEnabled && this.user.operator === '') {
        this.noOperatorSelected = true;
        this.hasErrors = true;
        this.operatorError = true;
      }
      if (!this.hasErrors || !this.operatorError) {
        this.message = '';
        if (this.hasResub()) {
          this.alternateForgotProcess()();
        } else {
          this.standardForgotProcess();
        }
      } else {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'conversionForArabicFields',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue